import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const PageMobileTitle = ({ title }) => (
	<Box sx={{ mx: 1 }} data-testid='page-mobile-title'>
		<Typography
			component='h1'
			variant='h5'
			sx={{
				my: 2,
			}}
		>
			{title}
		</Typography>
		<Divider sx={{ mb: 2 }} />
	</Box>
);

PageMobileTitle.propTypes = {
	title: PropTypes.string.isRequired,
};

export default PageMobileTitle;
